/* ============================================================
   HERB & HEAL - ICONS + DOM TAGGING

   1. Swaps every emoji used as iconography for a duotone line
      icon (same path drawn twice - soft wide stroke for weight,
      crisp thin stroke for definition).
   2. Tags elements CSS cannot otherwise reach, because these
      hand-coded sections wrap everything in unnamed divs:
        .hh-iconized--solo  icon with no text beside it, so the
                            round chip only lands on real icons
        .hh-on-dark         section with a dark background, so
                            icons and small print can invert
        .hh-legal           FDA / review disclaimer copy
   3. Applies copy fixes that belong in source.

   WHY JAVASCRIPT: the emoji and the copy are literal characters
   inside templates/index.json - one 44KB file holding all eleven
   hand-coded sections. CSS cannot reach a character. The correct
   fix is {% render 'hh-icon' %} at source, already built. Interim.

   COMPLIANCE - NOT COSMETIC: pill -> JAR, lungs -> AIRFLOW.
   A capsule implies a drug, an organ implies a disease target;
   both are the enforcement focus for supplements. Never revert.

   RATING STARS ARE FILLED, NOT OUTLINED (Aug 2026). A solid star
   and a hollow star are not two styles of the same symbol - they
   are 'rated' and 'not rated'. Drawing the line icon for the
   filled character rendered 4.86/5 as five empty outlines on
   every PDP, which reads to a visitor as zero reviews. The solid
   characters (star, glowing star, black star) now map to 'starf'
   and paint with fill; the hollow character keeps the line icon,
   because there it is doing the job it should.
   ============================================================ */
(function () {
  'use strict';

  var P = {
    leaf:   '<path d="M11 20A7 7 0 0 1 9.8 6.1C15.5 5 17 4.5 19 2c1 2 2 4.2 2 8 0 5.5-4.8 10-10 10Z"/><path d="M2 21c0-3 1.9-5.4 5.1-6C9.5 14.5 12 13 13 12"/>',
    sprout: '<path d="M7 20h10"/><path d="M12 20V9"/><path d="M12 9C12 6 9.5 4 6 4c0 3.5 2.5 5 6 5Z"/><path d="M12 12c0-2.5 2-4.5 5-4.5 0 3-2 4.5-5 4.5Z"/>',
    tea:    '<path d="M4 9h13v5a5 5 0 0 1-5 5H9a5 5 0 0 1-5-5V9Z"/><path d="M17 10h1.5a2.5 2.5 0 0 1 0 5H17"/><path d="M8 5.5c0-1 1-1.2 1-2.2M12 5.5c0-1 1-1.2 1-2.2"/>',
    jar:    '<path d="M8.5 3h7v3h-7z"/><path d="M7 6h10a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2Z"/><path d="M9 12h6"/>',
    wind:   '<path d="M3 8h9a2.5 2.5 0 1 0-2.5-2.5"/><path d="M3 12h13a3 3 0 1 1-3 3"/><path d="M3 16h7a2.5 2.5 0 1 1-2.5 2.5"/>',
    lab:    '<path d="M10 3v6.2L4.8 18a2 2 0 0 0 1.7 3h11a2 2 0 0 0 1.7-3L14 9.2V3"/><path d="M9 3h6M7.6 14.5h8.8"/>',
    truck:  '<path d="M3 7h11v9H3zM14 10h4l3 3v3h-7z"/><circle cx="7" cy="18" r="1.8"/><circle cx="17.5" cy="18" r="1.8"/>',
    refresh:'<path d="M20.5 12a8.5 8.5 0 1 1-2.6-6.1"/><path d="M20.5 4v5h-5"/>',
    shield: '<path d="M12 21s7-3.2 7-9V5.8L12 3 5 5.8V12c0 5.8 7 9 7 9Z"/><path d="m9.2 11.8 2 2 3.6-3.8"/>',
    check:  '<path d="m5 12.5 4.5 4.5L19 7.5"/>',
    checkc: '<circle cx="12" cy="12" r="9"/><path d="m8.2 12.2 2.6 2.6 5-5.4"/>',
    star:   '<path d="m12 3.6 2.7 5.5 6 .9-4.35 4.25 1.03 6L12 17.4l-5.38 2.85 1.03-6L3.3 10l6-.9L12 3.6Z"/>',
    starf:  '<path d="m12 3.6 2.7 5.5 6 .9-4.35 4.25 1.03 6L12 17.4l-5.38 2.85 1.03-6L3.3 10l6-.9L12 3.6Z"/>',
    bolt:   '<path d="M13 2 4.5 13.5H11L10 22l8.5-11.5H12L13 2Z"/>',
    box:    '<path d="M3 8.5 12 4l9 4.5V17L12 21l-9-4V8.5Z"/><path d="M3 8.5 12 13l9-4.5M12 13v8"/>',
    mail:   '<rect x="3" y="5" width="18" height="14" rx="2"/><path d="m3.5 6.5 8.5 6 8.5-6"/>',
    phone:  '<path d="M6.5 3h3l1.5 4-2 1.5a12 12 0 0 0 6.5 6.5L17 13l4 1.5v3a2 2 0 0 1-2.2 2A17 17 0 0 1 3.5 5.2 2 2 0 0 1 5.5 3Z"/>',
    pin:    '<path d="M12 21s7-5.4 7-11a7 7 0 1 0-14 0c0 5.6 7 11 7 11Z"/><circle cx="12" cy="10" r="2.6"/>',
    clock:  '<circle cx="12" cy="12" r="9"/><path d="M12 7v5.2l3.2 2"/>',
    heart:  '<path d="M12 20.5s-7.6-4.7-7.6-10A4.6 4.6 0 0 1 12 7.6a4.6 4.6 0 0 1 7.6 2.9c0 5.3-7.6 10-7.6 10Z"/>',
    globe:  '<circle cx="12" cy="12" r="9"/><path d="M3 12h18M12 3c2.5 2.6 3.8 5.7 3.8 9S14.5 18.4 12 21c-2.5-2.6-3.8-5.7-3.8-9S9.5 5.6 12 3Z"/>'
  };

  /* Icons that must paint solid rather than as a line drawing. */
  var FILLED = { starf: 1 };

  var MAP = {
    '🌿':'leaf','🍃':'leaf','🌱':'sprout','🌾':'sprout','🍵':'tea','☕':'tea',
    '💊':'jar','🫁':'wind','🧪':'lab','🔬':'lab','⚗':'lab',
    '🚚':'truck','📦':'box','🔄':'refresh','⚡':'bolt',
    '✅':'checkc','✔':'check','✓':'check',
    '⭐':'starf','★':'starf','☆':'star','🌟':'starf','🛡':'shield',
    '💚':'heart','❤':'heart','♡':'heart','♥':'heart',
    '✉':'mail','📧':'mail','📞':'phone','📍':'pin','🕐':'clock','⏰':'clock',
    '🌍':'globe','🌎':'globe','🌏':'globe'
  };

  var RE = /[☀-➿⬀-⯿️‍]|[\uD83C-\uD83E][\uDC00-\uDFFF]/g;

  /* Copy that should be changed in source, not here. */
  var COPY = [
    [/Free Shipping,\s*Always/gi, 'Free Shipping'],
    [/Free Shipping on Every Order\s*—\s*No Minimum/gi, 'Free Shipping on Every Order']
  ];

  function svg(name) {
    var d = P[name];

    /* A solid star and a hollow star are different meanings, not two
       styles of one icon. Anything in FILLED paints with fill and no
       stroke, so a rating reads as a rating. */
    if (FILLED[name]) {
      return '<svg class="hh-icon hh-icon--fill" viewBox="0 0 24 24" aria-hidden="true" focusable="false" ' +
             'fill="currentColor" stroke="none">' + d + '</svg>';
    }

    return '<svg class="hh-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false" ' +
           'fill="none" stroke="currentColor">' +
             '<g class="hh-i-ghost">' + d + '</g><g class="hh-i-line">' + d + '</g>' +
           '</svg>';
  }

  function isDark(el) {
    var c = getComputedStyle(el).backgroundColor.match(/\d+/g);
    if (!c || c.length < 3) return false;
    if (c.length > 3 && parseFloat(c[3]) < 0.5) return false;
    // Rec.601 luma
    return (0.299 * c[0] + 0.587 * c[1] + 0.114 * c[2]) < 130;
  }

  function processText(node) {
    var text = node.nodeValue;
    var next = text;

    for (var i = 0; i < COPY.length; i++) next = next.replace(COPY[i][0], COPY[i][1]);

    RE.lastIndex = 0;
    var hasEmoji = RE.test(next);
    RE.lastIndex = 0;

    if (!hasEmoji) {
      if (next !== text) node.nodeValue = next;
      return;
    }

    var stripped = next.replace(RE, '').trim();
    var html = next.replace(RE, function (ch) {
      if (ch === '️' || ch === '‍') return '';
      var k = MAP[ch];
      return k ? svg(k) : ch;
    });

    var span = document.createElement('span');
    // Only an icon and nothing else -> eligible for the round chip.
    // This is what stopped the chip painting a pale box behind the
    // whole ticker line.
    span.className = stripped ? 'hh-iconized' : 'hh-iconized hh-iconized--solo';
    span.innerHTML = html;
    node.parentNode.replaceChild(span, node);
  }

  function tag() {
    var secs = document.querySelectorAll('.shopify-section section, .shopify-section section > div, .hh-pp > div');
    for (var i = 0; i < secs.length; i++) {
      if (isDark(secs[i])) secs[i].classList.add('hh-on-dark');
    }
    var legal = /not been evaluated by the Food and Drug|not intended to diagnose|reflect individual experience/i;
    var all = document.querySelectorAll('p, div, span, small');
    for (var j = 0; j < all.length; j++) {
      var e = all[j];
      if (e.children.length === 0 && legal.test(e.textContent)) e.classList.add('hh-legal');
    }
  }

  function run() {
    var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        if (!n.nodeValue || !n.nodeValue.trim()) return NodeFilter.FILTER_REJECT;
        var p = n.parentNode;
        if (!p) return NodeFilter.FILTER_REJECT;
        var t = p.nodeName;
        if (t === 'SCRIPT' || t === 'STYLE' || t === 'TEXTAREA' || t === 'TITLE') return NodeFilter.FILTER_REJECT;
        if (p.closest && p.closest('#shopify-chat, .shopify-app-block')) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    var nodes = [], n;
    while ((n = walker.nextNode())) nodes.push(n);
    for (var i = 0; i < nodes.length; i++) processText(nodes[i]);
    tag();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }
})();
